import script from "./ChartTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ChartTemplate.vue?vue&type=style&index=0&id=1cfb7688&lang=scss"

const __exports__ = script;

export default __exports__